(function(){
  function sizeFieldset(c){
    var fs=c.querySelectorAll('fieldset');
    for(var i=0;i<fs.length;i++){
      var t=fs[i].querySelector('.product-common_variant-title');
      if(t && /tamanho|size/i.test(t.textContent)) return fs[i];
    }
    return null;
  }
  function atcOf(c){
    var scope=c.closest('.product-common')||document;
    return scope.querySelector('.product-common_atc-btn');
  }
  function gate(c){
    var f=sizeFieldset(c), atc=atcOf(c);
    if(!f||!atc) return;
    var picked=f.querySelector('input:checked');
    if(!picked){
      if(!atc.dataset.tLabel){atc.dataset.tLabel=atc.textContent.trim();}
      atc.textContent='Selecione o tamanho';
      atc.classList.add('t-atc-disabled');
      atc.setAttribute('aria-disabled','true');
    } else {
      atc.textContent=atc.dataset.tLabel||'Adicionar à sacola';
      atc.classList.remove('t-atc-disabled');
      atc.removeAttribute('aria-disabled');
    }
  }
  function init(){
    document.querySelectorAll('[id$="-variants-container"]').forEach(function(c){
      var f=sizeFieldset(c);
      if(f){var ch=f.querySelector('input:checked'); if(ch){ch.checked=false;}}
      gate(c);
      c.addEventListener('change',function(e){
        if(e.target && e.target.matches('input[type="radio"]')){
          var fld=e.target.closest('fieldset');
          var span=fld?fld.querySelector('.t-cor-nome'):null;
          if(span){span.textContent=e.target.value;}
          gate(c);
        }
      });
    });
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('.t-atc-disabled');
    if(b){e.preventDefault();e.stopPropagation();
      var c=document.querySelector('[id$="-variants-container"]');
      if(c){c.scrollIntoView({behavior:'smooth',block:'center'});}
    }
  },true);
  if(document.readyState!=='loading'){setTimeout(init,400);}
  else{document.addEventListener('DOMContentLoaded',function(){setTimeout(init,400);});}
})();

/* ===== Mega menu: injeta bolinha de cor antes de cada nome (comprar por cor) ===== */
(function(){
  var COLORS=[["cor=Preto","#1f1e1c"],["cor=Branco","#f2efe8"],["cor=Bege","#d8c7a4"],["cor=Marrom","#55381f"],["cor=Verde","#5c6045"],["cor=Azul","#27394e"]];
  function add(){
    var links=document.querySelectorAll('a[href*="filter.v.option.cor="]');
    for(var i=0;i<links.length;i++){
      var a=links[i];
      if(a.getElementsByClassName("tualma-swatch").length) continue;
      var href=decodeURIComponent(a.getAttribute("href")||"");
      var hex=null;
      for(var j=0;j<COLORS.length;j++){ if(href.indexOf(COLORS[j][0])>-1){ hex=COLORS[j][1]; break; } }
      if(!hex) continue;
      var s=document.createElement("span");
      s.className="tualma-swatch";
      s.style.cssText="display:inline-block;width:11px;height:11px;min-width:11px;border-radius:50%;margin-right:9px;vertical-align:-1px;border:1px solid rgba(0,0,0,.18);box-sizing:border-box;flex:0 0 auto;background:"+hex;
      a.insertBefore(s,a.firstChild);
    }
  }
  function boot(){ add(); setTimeout(add,600); setTimeout(add,1600); }
  if(document.readyState!=="loading"){ boot(); }
  else{ document.addEventListener("DOMContentLoaded",boot); }
})();

/* ===== PDP: trocar a FOTO principal ao clicar na COR (sync galeria <-> variante) =====
   Requer que a variante/cor tenha uma imagem atribuida no Shopify. Sem imagem = no-op. */
(function(){
  var hm = location.pathname.match(/\/products\/([^\/\?#]+)/);
  if(!hm) return;
  var handle = hm[1];
  var variantMap = {};   // variantId -> filename
  var colorMap = {};     // colorValue(lower) -> filename
  function fname(src){ return src ? String(src).split('/').pop().split('?')[0] : null; }
  function build(data){
    var opts = data.options || [];
    function on(o){ return typeof o==='string' ? o : ((o&&o.name)||''); }
    var colorPos = 0;
    for(var i=0;i<opts.length;i++){ if(/cor|colou?r/i.test(on(opts[i]))){ colorPos = i+1; break; } }
    (data.variants||[]).forEach(function(v){
      var fi = v.featured_image ? fname(v.featured_image.src) : null;
      if(!fi) return;
      variantMap[v.id] = fi;
      var cv = colorPos ? v['option'+colorPos] : (v.option2 || v.option1);
      if(cv){ var k = String(cv).toLowerCase(); if(!colorMap[k]) colorMap[k] = fi; }
    });
  }
  function slideIndexFor(sp, filename){
    try{
      var slides = sp.Components.Elements.slides;
      for(var i=0;i<slides.length;i++){
        var im = slides[i].querySelector('img');
        if(im && im.src.indexOf(filename) > -1) return i;
      }
    }catch(e){}
    return -1;
  }
  /* dispara a sequencia REAL de eventos (pointer+mouse) direto no elemento clicavel.
     O tema liga o handler ao overlay .product-common_image (nao ao <img> nem ao slide),
     entao miramos ESSE elemento -- elementFromPoint falha quando a miniatura esta sob um
     elemento fixo (ex.: 1a miniatura no topo, atras do header). */
  function dispatchEl(el){
    if(!el) return false;
    var r = el.getBoundingClientRect(), cx = r.left+r.width/2, cy = r.top+r.height/2;
    var o = {bubbles:true, cancelable:true, view:window, clientX:cx, clientY:cy};
    try{
      el.dispatchEvent(new PointerEvent('pointerdown', Object.assign({pointerId:1,isPrimary:true,button:0}, o)));
      el.dispatchEvent(new MouseEvent('mousedown', Object.assign({button:0}, o)));
      el.dispatchEvent(new PointerEvent('pointerup', Object.assign({pointerId:1,isPrimary:true,button:0}, o)));
      el.dispatchEvent(new MouseEvent('mouseup', Object.assign({button:0}, o)));
      el.dispatchEvent(new MouseEvent('click', Object.assign({button:0}, o)));
      return true;
    }catch(e){ return false; }
  }
  function mainShowing(){
    var a = document.querySelector('.main-thumb-slider .splide__slide.is-active img')
         || document.querySelector('.product-common_media-slider .splide__slide.is-active img');
    return a ? a.src : '';
  }
  function thumbImg(filename){
    var scope = document.querySelector('.product-common') || document;
    var imgs = [].slice.call(scope.querySelectorAll('.switcher-thumb-slider img, .product-common_slider-switcher img')).filter(function(i){
      if(i.src.indexOf(filename) < 0) return false;
      var sl = i.closest('.splide__slide'); if(sl && /clone/.test(sl.className)) return false;
      return true;
    });
    return imgs[0] || null;
  }
  /* trocar a foto principal = "clicar" na miniatura da cor (no topo do ponto).
     Guard: se a foto principal ja eh essa, nao faz nada (evita clique redundante). */
  function syncTo(filename){
    if(!filename) return;
    if(mainShowing().indexOf(filename) > -1) return;          // ja mostrando essa foto
    var im = thumbImg(filename);
    if(!im) return;
    var target = im.closest('.product-common_image') || im.parentElement || im;
    dispatchEl(target);
  }
  function selectedVariantFile(){
    var el = document.querySelector('.product-common [name="id"]') || document.querySelector('form[action*="/cart"] [name="id"]') || document.querySelector('[name="id"]');
    return el ? variantMap[el.value] : null;
  }
  /* O tema reconstroi a galeria de forma ASSINCRONA apos a troca de variante e clicar na
     miniatura DURANTE a reconstrucao nao funciona (e atrapalha os cliques seguintes). Por isso
     disparamos so DEPOIS que ela assenta (~1.2s), em 3 tentativas fixas; o guard "ja mostrando"
     evita clique redundante entre elas. */
  var _getter = null;
  function _fire(){ if(!_getter) return; var f = _getter(); if(f){ try{ syncTo(f); }catch(e){} } }
  function syncSoon(getFile){
    _getter = getFile;
    [1350, 2150, 3000].forEach(function(d){ setTimeout(_fire, d); });
  }
  var lastColorKey = null;
  /* preferir a foto da COR clicada. O id da variante ([name=id]) fica velho quando o tamanho
     ainda nao foi escolhido (size-gate), entao selectedVariantFile() devolveria a foto da cor
     ERRADA. A cor que o usuario clicou eh a fonte da verdade; variante so como ultimo recurso. */
  function currentFile(){
    if(lastColorKey && colorMap[lastColorKey]) return colorMap[lastColorKey];
    return selectedVariantFile();
  }
  function attach(){
    document.addEventListener('click', function(e){
      var lab = e.target.closest && e.target.closest('.product-variant-option_label--swatch');
      if(!lab || !lab.closest('[id$="-variants-container"]')) return;
      var val = null, inp = lab.previousElementSibling;
      if(inp && inp.value) val = inp.value;
      if(!val){ var vh = lab.querySelector('.visually-hidden'); if(vh) val = vh.textContent.trim(); }
      if(val){ lastColorKey = String(val).toLowerCase(); syncSoon(currentFile); }
    }, false);
    document.addEventListener('change', function(e){
      if(e.target && e.target.matches && e.target.matches('input[type="radio"]') && e.target.closest('[id$="-variants-container"]')){
        var v = e.target.value; if(v){ var lk = String(v).toLowerCase(); if(colorMap[lk] !== undefined) lastColorKey = lk; }
        syncSoon(currentFile);
      }
    }, false);
  }
  fetch('/products/'+handle+'.js', {headers:{'Accept':'application/json'}})
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(data){ if(data){ build(data); attach(); } })
    .catch(function(){});
})();
